import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { LoadsSharedModule } from '../loads-shared/loads-shared.module';
import { PhotoPickerActionSheetComponent } from '../shared/components/photo-picker-action-sheet/photo-picker-action-sheet.component';
import { ShipmentsRoutingModule } from './shipments-routing.module';

@NgModule({
  declarations: [
    PhotoPickerActionSheetComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,      // For PhotoPickerActionSheetComponent mat-button
    ShipmentsRoutingModule,
    LoadsSharedModule
  ]
})
export class ShipmentsModule { }
